interface Props {
  onRetry: () => void;
}

/** wasm (ゲームエンジン) のロード失敗時に盤の代わりに出す再試行バナー。 */
export function WasmError({ onRetry }: Props) {
  return (
    <div className="wasm-error" role="alert">
      <p>ゲームエンジンの読み込みに失敗しました。</p>
      <p className="muted">通信環境をご確認のうえ、もう一度お試しください。</p>
      <button type="button" onClick={onRetry}>
        再読み込み
      </button>
    </div>
  );
}
